import { defaultQuoteData } from "../default-quote-event-data";

export const defaultQuoteReviewData = {
  ...defaultQuoteData,
};
